module.exports = __webpack_public_path__ + "static/img/3A.e96bf4fe.svg";